import { settingsPage as EnUsSettingsPage } from '../en-us/settingsPage';
import { AgResourceLanguage } from '../types';

export const settingsPage: AgResourceLanguage['settingsPage'] = {
  ...EnUsSettingsPage,
  title: 'Account',
  emailAndPassword: {
    title: 'E-mail & Wachtwoord',
    changePasswordButton: 'Wachtwoord Wijzigen',
    emailChangeInfo: {
      informationText: 'E-mail kan alleen worden gewijzigd via',
      linkText: 'Customer Happiness'
    }
  },
  userInfo: {
    editButton: 'Bewerken',
    title: 'Volledige Naam'
  },
  modal: {
    changePassword: {
      cancelButton: 'Annuleren',
      confirmPasswordLabel: 'Bevestig Wachtwoord',
      header: 'Wachtwoord Wijzigen',
      infoBanner: 'Als je je wachtwoord wijzigt, word je automatisch uitgelogd',
      newPasswordLabel: 'Nieuw Wachtwoord',
      saveButton: 'Opslaan',
      title: 'Wachtwoord Wijzigen',
      success: 'Wachtwoord is gewijzigd',
      reloginError: 'Er ging iets mis, je wordt automatisch uitgelogd'
    },
    editFullName: {
      cancelButton: 'Annuleren',
      firstName: 'Voornaam',
      header: 'Volledige Naam Bewerken',
      lastName: 'Achternaam',
      saveButton: 'Opslaan',
      title: 'Volledige Naam'
    }
  },
  constants: {
    FULL_NAME_SUCCESS: 'Volledige naam succesvol gewijzigd',
    PASSWORD_MATCH_MESSAGE: 'De ingevoerde wachtwoorden komen niet overeen',
    SETTINGS_ERROR: 'Er ging iets mis. Probeer het opnieuw',
    nameError: 'Moet minstens 1 teken bevatten',
    latinNameError: 'Moet alleen Latijnse tekens bevatten',
    spacesNameError: 'Alleen spaties zijn niet toegestaan',
    minLength: 'Moet minstens 8 tekens bevatten',
    uppercase: '1 hoofdletter',
    lowercase: '1 kleine letter',
    number: '1 nummer',
    spacesPasswordError: 'Spaties zijn niet toegestaan',
    passwordCaption: 'Moet minstens 8 tekens bevatten'
  }
};
